import { useMemo } from "react";
import { Zap } from "lucide-react";
import { LOC_PT, ZONAS_RAPIDAS } from "./localizacoesPT";
import { paleta } from "./tokens";

const S = {
  label: { fontSize:12.5, fontWeight:500, color:paleta.cinza600, marginBottom:4, display:"block" },
  input: { width:"100%", padding:"9px 12px", border:"1px solid " + paleta.cinza200, borderRadius:8, fontSize:13.5, fontFamily:"inherit", background:"#fff", outline:"none", boxSizing:"border-box", color:paleta.cinza900 },
  pill: (active) => ({ padding:"5px 12px", borderRadius:999, fontSize:13, fontWeight:600, cursor:"pointer", border:"1px solid", borderColor: active?"#6B7385":paleta.cinza200, background: active?"#6B7385":"#fff", color: active?"#fff":paleta.navy900 }),
};

export default function SeletorLocalizacao({
  value = {},
  onChange,
  niveis = ["distrito","concelho","freguesia","morada"],
  cols = "1fr 1fr 1fr",
  obrigatorios = [],
  mostrarRapidas = true,
  compactoMorada = true,
}) {
  const distrito = value.distrito || "";
  const concelho = value.concelho || "";
  const freguesia = value.freguesia || "";
  const morada = value.morada || "";
  const cp = value.codigo_postal || "";

  const distritos = useMemo(() => Object.keys(LOC_PT).sort(), []);
  const concelhos = useMemo(() => distrito && LOC_PT[distrito] ? Object.keys(LOC_PT[distrito]).sort() : [], [distrito]);
  const freguesias = useMemo(() => distrito && concelho && LOC_PT[distrito]?.[concelho] ? LOC_PT[distrito][concelho] : [], [distrito, concelho]);

  const update = (patch) => onChange && onChange({ ...value, ...patch });

  const aplicarRapida = (rapida) => {
    update({ distrito: rapida.distrito||"", concelho: rapida.concelho||"", freguesia: rapida.freguesia||"" });
  };

  const isReq = (k) => obrigatorios.includes(k);

  return (
    <div>
      {mostrarRapidas && ZONAS_RAPIDAS && ZONAS_RAPIDAS.length > 0 && (
        <div style={{ marginBottom:10 }}>
          <label style={{ ...S.label, marginBottom:6, display:"inline-flex", alignItems:"center", gap:6 }}><Zap size={14} aria-hidden="true" />Zonas rápidas</label>
          <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
            {ZONAS_RAPIDAS.map(r => {
              const active = r.distrito === distrito && r.concelho === concelho && (r.freguesia||"") === (freguesia||"");
              return <button key={r.label} type="button" onClick={()=>aplicarRapida(r)} style={S.pill(active)}>{r.label}</button>;
            })}
          </div>
        </div>
      )}
      <div style={{ display:"grid", gridTemplateColumns:cols, gap:12, marginBottom:12 }}>
        {niveis.includes("distrito") && (
          <div>
            <label style={S.label}>Distrito {isReq("distrito") && "*"}</label>
            <select value={distrito} onChange={e=>update({ distrito: e.target.value, concelho:"", freguesia:"" })} style={{...S.input, border: isReq("distrito") && !distrito ? "1px solid " + paleta.perigo : S.input.border}}>
              <option value="">— Selecionar —</option>
              {distritos.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
        )}
        {niveis.includes("concelho") && (
          <div>
            <label style={S.label}>Concelho {isReq("concelho") && "*"}</label>
            <select value={concelho} onChange={e=>update({ concelho: e.target.value, freguesia:"" })} disabled={!distrito} style={{...S.input, opacity: distrito?1:0.5, border: isReq("concelho") && !concelho ? "1px solid " + paleta.perigo : S.input.border}}>
              <option value="">{distrito ? "— Selecionar —" : "Escolhe distrito"}</option>
              {concelhos.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        )}
        {niveis.includes("freguesia") && (
          <div>
            <label style={S.label}>Freguesia {isReq("freguesia") && "*"}</label>
            <select value={freguesia} onChange={e=>update({ freguesia: e.target.value })} disabled={!concelho} style={{...S.input, opacity: concelho?1:0.5}}>
              <option value="">{concelho ? (freguesias.length>0 ? "— Selecionar —" : "Sem freguesias") : "Escolhe concelho"}</option>
              {freguesias.map(f => <option key={f} value={f}>{f}</option>)}
            </select>
          </div>
        )}
      </div>
      {niveis.includes("morada") && (
        <div style={{ display:"grid", gridTemplateColumns: compactoMorada?"3fr 1fr":"1fr", gap:12 }}>
          <div>
            <label style={S.label}>Morada / Rua</label>
            <input value={morada} onChange={e=>update({ morada: e.target.value })} placeholder="Rua, número, andar..." style={S.input} />
          </div>
          {compactoMorada && (
            <div>
              <label style={S.label}>Código postal</label>
              <input value={cp} onChange={e=>update({ codigo_postal: e.target.value })} placeholder="0000-000" style={S.input} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
